module.exports = require("./Consent")
